import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { EqualsValidatorDirective } from './../../shared/directives/equals-validator.directive';
import { RequiredIfDirective } from './../../shared/directives/required-if.directive';
import { UppercaseDirective } from './../../shared/directives/uppercase.directive';

@NgModule({  
  declarations: [    
    EqualsValidatorDirective,
    RequiredIfDirective,
    UppercaseDirective
  ],
  exports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    EqualsValidatorDirective,
    RequiredIfDirective,
    UppercaseDirective
  ]
})
export class SharedModule { }
